import { useEffect, useState } from 'react';
import { ReactComponent as PLogo } from '../../assets/image/p-logo-bgc.svg';

interface HeroProps {
  timezone: string;
}

function Hero({ timezone }: HeroProps) {
  const [timezoneDisplay, setTimezoneDisplay] = useState<string>('');
  const [time, setTime] = useState<string>('');
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    const city = timezone.split('/')[1].replace('_', ' '); // Fallback city name
    const offset = -new Date().getTimezoneOffset() / 60;
    const sign = offset >= 0 ? '+' : '-';
    const utcOffset = `UTC${sign}${Math.abs(offset)}`;
    setTimezoneDisplay(`${city} (${utcOffset})`);
  }, []);

  useEffect(() => {
    const updateTimeAndDate = () => {
      const now = new Date();

      const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(now);

      const formattedDate = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }).format(now);

      setTime(formattedTime);
      setDate(formattedDate);
    };

    updateTimeAndDate();

    // Update the time every minute
    const intervalId = setInterval(updateTimeAndDate, 60 * 1000);

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  return (
    <section className="hero">
      <div className="hero-logo">
        <PLogo />
      </div>
      <div className="hero-content">
        <div className="upper">
          <p className="b1">{timezoneDisplay}</p>
          <h2>{time}</h2>
        </div>
        <h5>{date}</h5>
      </div>
    </section>
  );
}

export default Hero;
